// @flow

import * as React from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import AnalyseLabor from '../../../../Model/AnalyseLabor';

type Props = {
  labor: AnalyseLabor,
};

@observer
export default class AnalyseLaborEntry extends React.Component<Props, void> {
  @computed
  get entryString(): string {
    const {
      props: { labor },
    } = this;
    let value = labor.labor.name;
    if (labor.abteilung) {
      if (labor.abteilung.name && labor.abteilung.name.trim().length > 0) {
        value = `${value}, ${labor.abteilung.name}`;
      }
      if (labor.abteilung.telefon && labor.abteilung.telefon.trim().length > 0) {
        value = `${value}, Tel: ${labor.abteilung.telefon}`;
      }
    }
    // if (labor.uebermittlung && labor.uebermittlung.name && labor.uebermittlung.name.length > 0) {
    //   value = `${value}, ${labor.uebermittlung.name}`;
    // }
    return value;
  }

  render() {
    const { entryString } = this;

    return (
      <div>
        {entryString}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/AnalyseLaborEntry.js